import { XCircleIcon } from '@heroicons/react/20/solid'

export default function ValidationErrors({
  title = "There were some errors with your submission",
  errors = []
}) {
  if (!errors.length) return null;

  return (
    <div className="w-full max-w-full rounded-md bg-red-50 p-4 dark:bg-red-500/15 dark:outline dark:outline-red-500/25 overflow-hidden">
      <div className="flex">
        <div className="shrink-0">
          <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
        </div>
        <div className="ml-3 flex-1 min-w-0">
          <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
            {title}
          </h3>
          <div className="mt-2 text-sm text-red-700 dark:text-red-200/80 break-words whitespace-normal overflow-hidden">
            <ul role="list" className="list-disc space-y-1 pl-5">
              {errors.map((err, idx) => (
                <li className="ml-4 break-words whitespace-normal" key={idx}>
                  {err}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
